// Craft theme: força image swap ao usar dropdown de variantes
document.addEventListener('change', function (e) {
  const select = e.target.closest('variant-selects select');
  if (!select) return;

  const variantSelects = select.closest('variant-selects');
  if (!variantSelects) return;

  // Recolhe todos os valores de opção selecionados
  const selectedOptionValues = Array.from(
    variantSelects.querySelectorAll('select')
  ).map((s) => s.querySelector('option:checked')?.dataset?.optionValueId).filter(Boolean);

  // Publica o evento que o Craft usa para atualizar imagem e preço
  publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
    data: {
      event: e,
      target: select,
      selectedOptionValues,
    },
  });
});
